import AuthSerializer from './base';

export default class Status extends AuthSerializer {}
